export interface WebView {
  postMessage: (string: string) => void;
}

export const getWebView = (): WebView | undefined => {
  const anyWindow = window as any;
  return anyWindow.ReactNativeWebView;
};
